export const gender = [
  { id: 1, name: 'Masculino' },
  { id: 2, name: 'Femenino' },
]

export const docType = [
  { id: 1, name: 'Cédula de ciudadanía' },
  { id: 2, name: 'Cédual de extranjería' },
  { id: 3, name: 'Pasaporte' },
  { id: 4, name: 'Contraseña' },
  { id: 5, name: 'NUIP' },
]

//////// INCAUTACION

export const autorityType = [
  { id: 1, name: 'Policia Nacional' },
]


//////// PUBLICIDAD

export const advType = [
  { id: 1, name: 'Almacén de ropa/calzado' },
  { id: 2, name: 'Almacén de misceláneos/decoración/artículos para el hogar' },
  { id: 3, name: 'Mercado/carnicería/fruver' },
  { id: 4, name: 'Restaurante/Panadería/pastelería/repostería/café' },
  { id: 5, name: 'Bar/licorera/Expendio de licores' },
  { id: 6, name: 'Reparación de celulares/relojería/sastrería/remontadora de calzado/electrodomésticos' },
  { id: 7, name: 'Taller automotriz/motocicletas/metalmecánica/carpintería' },
  { id: 8, name: 'Almacén de repuestos' },
  { id: 9, name: 'Papelería/librería/Puesto de revistas' },
  { id: 10, name: 'Tienda de peluquero/maquillaje/bisutería' },
  { id: 11, name: 'Peluquería/Salón de belleza/spa de uñas/belleza en general' },
  { id: 12, name: 'Centro médico/odontológico/salud en general' },
  { id: 13, name: 'Farmacia/Óptica/Bótica' },
  { id: 14, name: 'Otro' },
]



//////// OPERATIVO

export const operType = [
  { id: 1, name: 'Pedagógico' },
  { id: 2, name: 'Apoyo a la Gestión' },
  { id: 3, name: 'Incautación' },
]

export const liders = [
  { id: 1, name: 'Luis Riveros' },
  { id: 2, name: 'Alfredo Bolaños' },
  { id: 3, name: 'Victor Villanueva' },
  { id: 4, name: 'Walvin Ospina' },
  { id: 5, name: 'José Castrillón' },
]

export const gardians = [
  { id: 1, name: 'CAMILO GARCIA' },
  { id: 2, name: 'CARLOS MELOS' },
  { id: 19, name: 'CARLOS MELOS' },
  { id: 3, name: 'DARIO PUPO' },
  { id: 4, name: 'JAIME ANDRADE' },
  { id: 5, name: 'JAIME GARCIA' },
  { id: 6, name: 'JANER CARBARCAS' },
  { id: 7, name: 'JOSE SANCHEZ' },
  { id: 8, name: 'LUIS PALMEZANO' },
  { id: 9, name: 'MAICOL RODRIGUEZ' },
  { id: 10, name: 'MIGUEL CASTILLA' },
  { id: 11, name: 'NERALDIS BAYONA' },
  { id: 12, name: 'NORBEY YANETH' },
  { id: 13, name: 'REYNEL DONADO' },
  { id: 14, name: 'ROMARIO GONZALEZ' },
  { id: 15, name: 'SANTIAGO MIRANDA' },
  { id: 16, name: 'SILVERIO GALVAN' },
  { id: 17, name: 'VLADIMIR OLIVEROS' },
  { id: 18, name: 'WILLY SALCEDO' },
]

export const intervieners = [
  { id: 1, name: 'Gobierno' },
  { id: 2, name: 'Planeación' },
  { id: 3, name: 'DADSA' },
  { id: 4, name: 'Personería' },
  { id: 5, name: 'Policía' },
  { id: 6, name: 'DIMAR' },
  { id: 7, name: 'Migración' },
  { id: 8, name: 'Movilidad' },
  { id: 9, name: 'Otro' },
]

export const spaceWas = [
  { id: 1, name: 'Recuperado' },
  { id: 2, name: 'Defendido' },
  { id: 3, name: 'Organizado' }
]

//////// CENSO GALERÍA

export const awardedTypes = [
  { id: 1, name: 'Adjudicado' },
  { id: 2, name: 'Arrendado' },
  { id: 3, name: 'Si' },
  { id: 4, name: 'No' },
]

export const timeUnit = [
  { id: 1, name: 'Años' },
  { id: 2, name: 'Meses' },
]

export const galeryType = [
  { id: 1, name: 'Mercado' },
  { id: 2, name: 'Locales' },
]

export const activityType = [
  { id: 1, name: 'Accesorios' },
  { id: 2, name: 'Bodega' },
  { id: 3, name: 'Bordados' },
  { id: 4, name: 'Cafetería y/o refresquería' },
  { id: 5, name: 'Calzado' },
  { id: 6, name: 'Electrodomésticos' },
  { id: 7, name: 'Fotocopias' },
  { id: 8, name: 'Joyería' },
  { id: 9, name: 'Librería' },
  { id: 10, name: 'Modistería' },
  { id: 11, name: 'Odonotología' },
  { id: 12, name: 'Plantas medicinales' },
  { id: 13, name: 'Relojería' },
  { id: 14, name: 'Restaurante' },
  { id: 15, name: 'Ropa' },
  { id: 16, name: 'Salón de Belleza' },
  { id: 17, name: 'Servicio de reparación' },
  { id: 18, name: 'Tecnología' },
  { id: 19, name: 'Tienda Naturista' },
  { id: 20, name: 'Transferencia a Venezuela' },
  { id: 21, name: 'Variedades' },
  { id: 22, name: 'Otros' },
]

export const frecContrb = [
  { id: 1, name: 'Diario' },
  { id: 2, name: 'Semanal' },
  { id: 3, name: 'Quincenal' },
  { id: 4, name: 'Mensual' },
]

export const networks = [
  { id: 1, name: 'No tiene' },
  { id: 2, name: 'Facebook' },
  { id: 3, name: 'Instagram' },
  { id: 4, name: 'TikTok' },
  { id: 5, name: 'x (Twitter)' },
  { id: 6, name: 'Otra' },
]

export const banks = [
  { id: 1, name: 'No tiene' },
  { id: 2, name: 'Bancolomia' },
  { id: 3, name: 'Daviplata' },
  { id: 4, name: 'Nequi' },
  { id: 5, name: 'Otra' },
]

//////// GEOGRÁFICO

export const comunas = [
  { id: 1, name: '1. Cultural Tayrona - San Pedro Alejandrino', },
  { id: 2, name: '2. Histórica - Rodrigo de Bastidas', },
  { id: 3, name: '3. Turística - Perla del Caribe', },
]

export const barrios = [
  { id: 55, refComunaId: 1, name: 'CAÑAVERAL' },
  { id: 50, refComunaId: 1, name: 'CENTRAL DE TRANSPORTE' },
  { id: 92, refComunaId: 2, name: 'CARDONALES' },
  { id: 102, refComunaId: 2, name: 'BASTIDAS' },
  { id: 47, refComunaId: 2, name: '7 DE AGOSTO' },
  { id: 81, refComunaId: 2, name: '8 DE DICIEMBRE' },
  { id: 61, refComunaId: 1, name: '8 DE FEBRERO' },
  { id: 40, refComunaId: 2, name: '13 DE JUNIO' },
  { id: 101, refComunaId: 2, name: '17 DE DICIEMBRE' },
  { id: 134, refComunaId: 1, name: '19 DE ABRIL' },
  { id: 9, refComunaId: 2, name: '20 DE JULIO' },
  { id: 156, refComunaId: 1, name: '20 DE OCTUBRE' },
  { id: 194, refComunaId: 3, name: 'ABAJO' },
  { id: 206, refComunaId: 1, name: 'ACACIAS' },
  { id: 133, refComunaId: 3, name: 'ADS' },
  { id: 127, refComunaId: 3, name: 'AEROMAR' },
  { id: 126, refComunaId: 3, name: 'AEROPUERTO' },
  { id: 17, refComunaId: 2, name: 'ALAMBIQUE' },
  { id: 37, refComunaId: 2, name: 'ALCÁZARES' },
  { id: 34, refComunaId: 2, name: 'ALFONSO LÓPEZ' },
  { id: 26, refComunaId: 2, name: 'ALMENDROS' },
  { id: 103, refComunaId: 2, name: 'ALTOS LAS DELICIAS' },
  { id: 214, refComunaId: 2, name: 'ALTOS VILLA CONCHA' },
  { id: 141, refComunaId: 1, name: 'ALTOS SANTA CRUZ' },
  { id: 149, refComunaId: 1, name: 'ANDREA CAROLINA' },
  { id: 108, refComunaId: 2, name: 'ARMERO' },
  { id: 211, refComunaId: 1, name: 'ASOCOM' },
  { id: 190, refComunaId: 1, name: 'BATALLÓN DE INFANTERÍA' },
  { id: 176, refComunaId: 2, name: 'BAVARIA' },
  { id: 215, refComunaId: 2, name: 'BALCONES DEL LIBERTADOR' },
  { id: 22, refComunaId: 2, name: 'BELLA VISTA' },
  { id: 27, refComunaId: 2, name: 'BETANIA' },
  { id: 16, refComunaId: 2, name: 'BOLÍVAR' },
  { id: 79, refComunaId: 1, name: 'BOLIVARIANA' },
  { id: 111, refComunaId: 1, name: 'BOLÍVAR DEL RÍO' },
  { id: 205, refComunaId: 1, name: 'BOULEVARD DE LAS ROSAS' },
  { id: 173, refComunaId: 1, name: 'BOULEVARD LA 19' },
  { id: 218, refComunaId: 2, name: 'BUENOS AIRES' },
  { id: 112, refComunaId: 1, name: 'CANTILITO I, II, III, IV' },
  { id: 3, refComunaId: 2, name: 'CENTRO' },
  { id: 147, refComunaId: 1, name: 'CEMENTOS CARIBE' },
  { id: 123, refComunaId: 3, name: 'CERRO LA GLORIA' },
  { id: 166, refComunaId: 3, name: 'CERRO LA LLORONA' },
  { id: 167, refComunaId: 3, name: 'CERRO SAN FERNANDO' },
  { id: 104, refComunaId: 2, name: 'CHIMILA 1 Y 2' },
  { id: 143, refComunaId: 1, name: 'CIUDAD DEL SOL' },
  { id: 158, refComunaId: 1, name: 'CIUDAD EQUIDAD' },
  { id: 178, refComunaId: 1, name: 'CIUDADELA 29 DE JULIO' },
  { id: 118, refComunaId: 1, name: 'COLINAS DEL RIO' },
  { id: 153, refComunaId: 1, name: 'CONJ RES EL NOGAL' },
  { id: 184, refComunaId: 1, name: 'COREA' },
  { id: 130, refComunaId: 3, name: 'CRISTO REY' },
  { id: 38, refComunaId: 2, name: 'CUNDÍ' },
  { id: 136, refComunaId: 1, name: 'CURINCA' },
  { id: 106, refComunaId: 2, name: 'DIVINO NIÑO' },
  { id: 168, refComunaId: 3, name: 'DOCE DE OCTUBRE' },
  { id: 129, refComunaId: 3, name: 'DON JACA PARTE ALTA' },
  { id: 128, refComunaId: 3, name: 'DON JACA PARTE BAJA' },
  { id: 132, refComunaId: 3, name: 'ECOPETROL' },
  { id: 170, refComunaId: 3, name: 'EDUARDO VIVES' },
  { id: 84, refComunaId: 1, name: 'EL BOSQUE' },
  { id: 161, refComunaId: 1, name: 'EL CISNE' },
  { id: 64, refComunaId: 1, name: 'EL MAYOR' },
  { id: 95, refComunaId: 2, name: 'EL PANTANO' },
  { id: 179, refComunaId: 1, name: 'EL PANDO' },
  { id: 14, refComunaId: 2, name: 'EL PRADO' },
  { id: 10, refComunaId: 2, name: 'EL PRADITO' },
  { id: 12, refComunaId: 2, name: 'EL PUEBLITO' },
  { id: 30, refComunaId: 2, name: 'EL RECREO' },
  { id: 86, refComunaId: 1, name: 'EL REFUGIO' },
  { id: 53, refComunaId: 1, name: 'EL TRÉBOL' },
  { id: 119, refComunaId: 2, name: 'ENSENADA JUAN XXIII 1 Y 2' },
  { id: 8, refComunaId: 2, name: 'ENSENADA OLAYA' },
  { id: 99, refComunaId: 2, name: 'ESMERALDA' },
  { id: 63, refComunaId: 2, name: 'FABRICA BAVARIA' },
  { id: 216, refComunaId: 2, name: 'FLORIDA' },
  { id: 193, refComunaId: 3, name: 'GAIRA' },
  { id: 109, refComunaId: 2, name: 'GALÁN' },
  { id: 96, refComunaId: 2, name: 'GALICIA' },
  { id: 144, refComunaId: 1, name: 'FILADELFIA' },
  { id: 44, refComunaId: 2, name: 'JARDÍN' },
  { id: 45, refComunaId: 2, name: 'JUAN XXIII' },
  { id: 77, refComunaId: 2, name: 'JUNÍN' },
  { id: 69, refComunaId: 2, name: 'LOS NARANJOS' },
  { id: 121, refComunaId: 3, name: 'LA RIVIERA' },
  { id: 124, refComunaId: 3, name: 'LAGO DULCINO' },
  { id: 131, refComunaId: 3, name: 'LA PAZ' },
  { id: 171, refComunaId: 3, name: 'LA QUEMADA' },
  { id: 15, refComunaId: 2, name: 'LA ESPERANZA' },
  { id: 93, refComunaId: 2, name: 'LA ESTRELLA' },
  { id: 197, refComunaId: 1, name: 'LA LUCHA' },
  { id: 198, refComunaId: 3, name: 'LA MAGDALENA' },
  { id: 20, refComunaId: 2, name: 'LA TENERÍA' },
  { id: 183, refComunaId: 1, name: 'LAS AMÉRICAS' },
  { id: 181, refComunaId: 1, name: 'LAS COLINAS DEL PANDO' },
  { id: 62, refComunaId: 1, name: 'LAS MALVINAS' },
  { id: 75, refComunaId: 1, name: 'LAS VEGAS' },
  { id: 68, refComunaId: 2, name: 'LAS VILLAS' },
  { id: 46, refComunaId: 2, name: 'LIBERTADOR' },
  { id: 207, refComunaId: 3, name: 'LOMA FRESCA' },
  { id: 19, refComunaId: 2, name: 'LOS ÁNGELES' },
  { id: 204, refComunaId: 1, name: 'LOS FAROLES' },
  { id: 110, refComunaId: 2, name: 'LOS FUNDADORES' },
  { id: 54, refComunaId: 1, name: 'LOS LAURELES' },
  { id: 200, refComunaId: 3, name: 'LOS LIRIOS' },
  { id: 138, refComunaId: 1, name: 'LOS NOGALES' },
  { id: 13, refComunaId: 2, name: 'LOS TRONCOS' },
  { id: 209, refComunaId: 1, name: 'LOS TRUPILLOS' },
  { id: 105, refComunaId: 2, name: 'LUIS R. CALVO' },
  { id: 135, refComunaId: 1, name: 'LUZ DEL MUNDO' },
  { id: 82, refComunaId: 1, name: 'MAMATOCO' },
  { id: 24, refComunaId: 2, name: 'MANGUITOS' },
  { id: 188, refComunaId: 1, name: 'MANZANARES' },
  { id: 185, refComunaId: 1, name: 'MARÍA EUGENIA' },
  { id: 187, refComunaId: 1, name: 'MARTINETE' },
  { id: 213, refComunaId: 2, name: 'MIGUEL PINEDO' },
  { id: 177, refComunaId: 2, name: 'MINUTO DE DIOS' },
  { id: 21, refComunaId: 2, name: 'MIRA MAR' },
  { id: 154, refComunaId: 1, name: 'MIRACAMPESTRE' },
  { id: 11, refComunaId: 2, name: 'MIRAFLOREZ' },
  { id: 192, refComunaId: 3, name: 'MODELO' },
  { id: 157, refComunaId: 1, name: 'MONTERREY' },
  { id: 180, refComunaId: 1, name: 'MURALLAS' },
  { id: 1, refComunaId: 2, name: 'NACHO VIVES' },
  { id: 199, refComunaId: 3, name: 'NUEVA BETEL' },
  { id: 88, refComunaId: 2, name: 'NUEVA GALICIA' },
  { id: 114, refComunaId: 1, name: 'NUEVA MANSIÓN' },
  { id: 165, refComunaId: 1, name: 'NUEVA COLOMBIA' },
  { id: 71, refComunaId: 2, name: 'NUEVO JARDÍN' },
  { id: 117, refComunaId: 1, name: 'NUEVO MILENIO' },
  { id: 28, refComunaId: 2, name: 'OBRERO' },
  { id: 5, refComunaId: 2, name: 'OLAYA HERRERA' },
  { id: 33, refComunaId: 2, name: 'OLIVO' },
  { id: 72, refComunaId: 2, name: 'POSTOBON' },
  { id: 73, refComunaId: 2, name: 'PORVENIR' },
  { id: 74, refComunaId: 2, name: 'PEREHUETANO' },
  { id: 80, refComunaId: 1, name: 'QUINTA DE SAN PEDRO' },
  { id: 90, refComunaId: 2, name: 'PARAÍSO' },
  { id: 107, refComunaId: 2, name: 'ONDAS DEL CARIBE' },
  { id: 116, refComunaId: 1, name: 'TIMAYUI I, II, III' },
  { id: 122, refComunaId: 3, name: 'RINCON GUAPO' },
  { id: 125, refComunaId: 3, name: 'PLENO MAR' },
  { id: 137, refComunaId: 1, name: 'PARQUE' },
  { id: 155, refComunaId: 1, name: 'ONCE DE NOVIEMBRE' },
  { id: 217, refComunaId: 2, name: 'OASIS' },
  { id: 186, refComunaId: 1, name: 'PASTRANA' },
  { id: 7, refComunaId: 2, name: 'PESCAITO' },
  { id: 202, refComunaId: 3, name: 'POZOS COLORADOS' },
  { id: 182, refComunaId: 1, name: 'PRIMERO DE MAYO' },
  { id: 174, refComunaId: 1, name: 'PRIVILEGIO' },
  { id: 203, refComunaId: 3, name: 'PUERTO MOSQUITO' },
  { id: 191, refComunaId: 3, name: 'RODADERO TRADICIONAL' },
  { id: 162, refComunaId: 1, name: 'RODRIGO AHUMADA' },
  { id: 196, refComunaId: 3, name: 'SALGUERO' },
  { id: 89, refComunaId: 2, name: 'SALVADOR' },
  { id: 32, refComunaId: 2, name: 'SAN FRANCISCO' },
  { id: 35, refComunaId: 2, name: 'SAN FERNANDO' },
  { id: 36, refComunaId: 2, name: 'SAN JORGE' },
  { id: 39, refComunaId: 2, name: 'SAN JOSÉ' },
  { id: 4, refComunaId: 2, name: 'SAN MARTÍN' },
  { id: 140, refComunaId: 1, name: 'SANTA CLARA' },
  { id: 146, refComunaId: 1, name: 'SANTA CRUZ' },
  { id: 189, refComunaId: 1, name: 'SAN PABLO' },
  { id: 65, refComunaId: 2, name: 'SANTA HELENA' },
  { id: 51, refComunaId: 1, name: 'SANTA ANA' },
  { id: 66, refComunaId: 2, name: 'SANTA CATALINA 2000' },
  { id: 67, refComunaId: 2, name: 'SANTA CATALINA' },
  { id: 98, refComunaId: 2, name: 'SANTA LUCIA' },
  { id: 100, refComunaId: 2, name: 'SANTA MÓNICA' },
  { id: 94, refComunaId: 2, name: 'SANTAFÉ' },
  { id: 172, refComunaId: 3, name: 'SARABANDA' },
  { id: 41, refComunaId: 2, name: 'SENA' },
  { id: 76, refComunaId: 1, name: 'SIMÓN BOLÍVAR' },
  { id: 59, refComunaId: 1, name: 'Sin Nombre' },
  { id: 120, refComunaId: 3, name: 'Sin Nombre' },
  { id: 49, refComunaId: 1, name: 'TALLERES DEPARTAMENTO' },
  { id: 212, refComunaId: 1, name: 'TAMACÁ' },
  { id: 18, refComunaId: 2, name: 'TAMINACA 1 Y 2' },
  { id: 87, refComunaId: 2, name: 'TAYRONA 1 Y 2' },
  { id: 150, refComunaId: 1, name: 'TEJARES DEL LIBERTADOR' },
  { id: 2, refComunaId: 2, name: 'TERMINAL MARÍTIMA' },
  { id: 23, refComunaId: 2, name: 'TERRITORIAL' },
  { id: 52, refComunaId: 1, name: 'UNIMAGDALENA' },
  { id: 83, refComunaId: 1, name: 'URB ALEJANDRINA' },
  { id: 42, refComunaId: 2, name: 'URB BENJAMÍN ALZATE' },
  { id: 142, refComunaId: 1, name: 'URB CONCEPCIÓN 1,2,3,4,5' },
  { id: 113, refComunaId: 1, name: 'URB GARAGOA' },
  { id: 29, refComunaId: 2, name: 'URB LAS DELICIAS' },
  { id: 31, refComunaId: 2, name: 'URB RIASCOS' },
  { id: 159, refComunaId: 1, name: 'URB ROSALÍA' },
  { id: 48, refComunaId: 2, name: 'URB SAN PEDRO ALEJANDRINO' },
  { id: 152, refComunaId: 1, name: 'URB SIERRA ADENTRO' },
  { id: 151, refComunaId: 1, name: 'URB SIERRA NEVADA' },
  { id: 148, refComunaId: 1, name: 'URB TERRANOVA' },
  { id: 160, refComunaId: 1, name: 'URB VILLA CAMILA' },
  { id: 70, refComunaId: 2, name: 'URBANIZACIÓN LOS CERROS' },
  { id: 175, refComunaId: 2, name: 'URBANIZACIÓN EL REFUGIO' },
  { id: 25, refComunaId: 2, name: 'VERACRUZ' },
  { id: 195, refComunaId: 3, name: 'VILLA BERLÍN' },
  { id: 139, refComunaId: 1, name: 'VILLA BETHEL' },
  { id: 115, refComunaId: 1, name: 'VILLA DANIA' },
  { id: 208, refComunaId: 1, name: 'VILLA DEL CARMEN' },
  { id: 78, refComunaId: 2, name: 'VILLA DEL RÍO' },
  { id: 85, refComunaId: 1, name: 'VILLA ELY' },
  { id: 145, refComunaId: 1, name: 'VILLA ITALIA' },
  { id: 56, refComunaId: 1, name: 'VILLA MARBELLA' },
  { id: 57, refComunaId: 1, name: 'VILLA MARINA' },
  { id: 210, refComunaId: 1, name: 'VILLA MERCEDES' },
  { id: 60, refComunaId: 1, name: 'VILLA MÓNICA' },
  { id: 43, refComunaId: 2, name: 'VILLA OLÍMPICA' },
  { id: 91, refComunaId: 2, name: 'VILLA PACHÍN' },
  { id: 97, refComunaId: 2, name: 'VILLA SARA' },
  { id: 219, refComunaId: 3, name: 'VILLA TANGA' },
  { id: 201, refComunaId: 3, name: 'VILLA TAROA' },
  { id: 163, refComunaId: 1, name: 'VILLA TOLEDO' },
  { id: 58, refComunaId: 1, name: 'VILLA U' },
  { id: 169, refComunaId: 3, name: 'VUELTA DEL CAUCA' },
  { id: 164, refComunaId: 1, name: 'YUCAL 1 Y 2' },
  { id: 6, refComunaId: 2, name: 'ZONA DEL MERCADO' },
  { id: 220, refComunaId: 2, name: 'TAGANGA' },
]

export const countries = [
  { id: 40, name: 'COLOMBIA' },
  { id: 189, name: 'VENEZUELA' },
  { id: 1, name: 'AFGANISTÁN' },
  { id: 2, name: 'ALBANIA' },
  { id: 3, name: 'ALEMANIA' },
  { id: 4, name: 'ANDORRA' },
  { id: 5, name: 'ANGOLA' },
  { id: 6, name: 'ANTIGUA Y BARBUDA' },
  { id: 7, name: 'ARABIA SAUDITA' },
  { id: 8, name: 'ARGELIA' },
  { id: 9, name: 'ARGENTINA' },
  { id: 10, name: 'ARMENIA' },
  { id: 11, name: 'AUSTRALIA' },
  { id: 12, name: 'AUSTRIA' },
  { id: 13, name: 'AZERBAIYÁN' },
  { id: 14, name: 'BAHAMAS' },
  { id: 15, name: 'BANGLADÉS' },
  { id: 16, name: 'BARBADOS' },
  { id: 17, name: 'BARÉIN' },
  { id: 18, name: 'BÉLGICA' },
  { id: 19, name: 'BELICE' },
  { id: 20, name: 'BENIN' },
  { id: 21, name: 'BIELORRUSIA' },
  { id: 22, name: 'BOLIVIA' },
  { id: 23, name: 'BOSNIA Y HERZEGOVINA' },
  { id: 24, name: 'BOTSUANA' },
  { id: 25, name: 'BRASIL' },
  { id: 26, name: 'BRUNEI' },
  { id: 27, name: 'BULGARIA' },
  { id: 28, name: 'BURKINA FASO' },
  { id: 29, name: 'BURUNDI' },
  { id: 30, name: 'BUTÁN' },
  { id: 31, name: 'CABO VERDE' },
  { id: 32, name: 'CAMBOYA' },
  { id: 33, name: 'CAMERÚN' },
  { id: 34, name: 'CANADÁ' },
  { id: 35, name: 'CATAR' },
  { id: 36, name: 'CHAD' },
  { id: 37, name: 'CHILE' },
  { id: 38, name: 'CHINA' },
  { id: 39, name: 'CHIPRE' },
  { id: 41, name: 'COMORAS' },
  { id: 42, name: 'COREA DEL NORTE' },
  { id: 43, name: 'COREA DEL SUR' },
  { id: 44, name: 'COSTA DE MARFIL' },
  { id: 45, name: 'COSTA RICA' },
  { id: 46, name: 'CROACIA' },
  { id: 47, name: 'CUBA' },
  { id: 48, name: 'DINAMARCA' },
  { id: 49, name: 'DOMINICA' },
  { id: 50, name: 'ECUADOR' },
  { id: 51, name: 'EGIPTO' },
  { id: 52, name: 'EL SALVADOR' },
  { id: 53, name: 'EMIRATOS ARABES UNIDOS' },
  { id: 54, name: 'ERITREA' },
  { id: 55, name: 'ESLOVAQUIA' },
  { id: 56, name: 'ESLOVENIA' },
  { id: 57, name: 'ESPAÑA' },
  { id: 58, name: 'ESTADOS UNIDOS' },
  { id: 59, name: 'ESTONIA' },
  { id: 60, name: 'ETIOPÍA' },
  { id: 61, name: 'FILIPINAS' },
  { id: 62, name: 'FINLANDIA' },
  { id: 63, name: 'FIYI' },
  { id: 64, name: 'FRANCIA' },
  { id: 65, name: 'GABÓN' },
  { id: 66, name: 'GAMBIA' },
  { id: 67, name: 'GEORGIA' },
  { id: 68, name: 'GHANA' },
  { id: 69, name: 'GRANADA' },
  { id: 70, name: 'GRECIA' },
  { id: 71, name: 'GUATEMALA' },
  { id: 72, name: 'GUINEA' },
  { id: 73, name: 'GUINEA ECUATORIAL' },
  { id: 74, name: 'GUINEA-BISSAU' },
  { id: 75, name: 'GUYANA' },
  { id: 76, name: 'HAITÍ' },
  { id: 77, name: 'HONDURAS' },
  { id: 78, name: 'HUNGRÍA' },
  { id: 79, name: 'INDIA' },
  { id: 80, name: 'INDONESIA' },
  { id: 81, name: 'IRÁN' },
  { id: 82, name: 'IRAQ' },
  { id: 83, name: 'IRLANDA' },
  { id: 84, name: 'ISLANDIA' },
  { id: 85, name: 'ISLAS MARSHALL' },
  { id: 86, name: 'ISLAS SALOMÓN' },
  { id: 87, name: 'ISRAEL' },
  { id: 88, name: 'ITALIA' },
  { id: 89, name: 'JAMAICA' },
  { id: 90, name: 'JAPÓN' },
  { id: 91, name: 'JORDANIA' },
  { id: 92, name: 'KAZAJISTÁN' },
  { id: 93, name: 'KENIA' },
  { id: 94, name: 'KIRGUISTÁN' },
  { id: 95, name: 'KIRIBATI' },
  { id: 96, name: 'KUWAIT' },
  { id: 97, name: 'LAOS' },
  { id: 98, name: 'LESOTO' },
  { id: 99, name: 'LETONIA' },
  { id: 100, name: 'LÍBANO' },
  { id: 101, name: 'LIBERIA' },
  { id: 102, name: 'LIBIA' },
  { id: 103, name: 'LIECHTENSTEIN' },
  { id: 104, name: 'LITUANIA' },
  { id: 105, name: 'LUXEMBURGO' },
  { id: 106, name: 'MADAGASCAR' },
  { id: 107, name: 'MALASIA' },
  { id: 108, name: 'MALAUI' },
  { id: 109, name: 'MALDIVAS' },
  { id: 110, name: 'MALI' },
  { id: 111, name: 'MALTA' },
  { id: 112, name: 'MARRUECOS' },
  { id: 113, name: 'MAURICIO' },
  { id: 114, name: 'MAURITANIA' },
  { id: 115, name: 'MÉXICO' },
  { id: 116, name: 'MICRONESIA' },
  { id: 117, name: 'MOLDAVIA' },
  { id: 118, name: 'MÓNACO' },
  { id: 119, name: 'MONGOLIA' },
  { id: 120, name: 'MONTENEGRO' },
  { id: 121, name: 'MOZAMBIQUE' },
  { id: 122, name: 'MYANMAR (BIRMANIA)' },
  { id: 123, name: 'NAMIBIA' },
  { id: 124, name: 'NAURU' },
  { id: 125, name: 'NEPAL' },
  { id: 126, name: 'NICARAGUA' },
  { id: 127, name: 'NÍGER' },
  { id: 128, name: 'NIGERIA' },
  { id: 129, name: 'NORUEGA' },
  { id: 130, name: 'NUEVA ZELANDA' },
  { id: 131, name: 'OMÁN' },
  { id: 132, name: 'PAÍSES BAJOS' },
  { id: 133, name: 'PAKISTÁN' },
  { id: 134, name: 'PALAOS' },
  { id: 135, name: 'PALESTINA' },
  { id: 136, name: 'PANAMÁ' },
  { id: 137, name: 'PAPÚA NUEVA GUINEA' },
  { id: 138, name: 'PARAGUAY' },
  { id: 139, name: 'PERÚ' },
  { id: 140, name: 'POLONIA' },
  { id: 141, name: 'PORTUGAL' },
  { id: 142, name: 'PUERTO RICO' },
  { id: 143, name: 'REINO UNIDO' },
  { id: 144, name: 'REPÚBLICA CENTROAFRICANA' },
  { id: 145, name: 'REPÚBLICA CHECA' },
  { id: 146, name: 'REPÚBLICA DE MACEDONIA' },
  { id: 147, name: 'REPÚBLICA DEL CONGO' },
  { id: 148, name: 'REPÚBLICA DEMOCRÁTICA DEL CONGO' },
  { id: 149, name: 'REPÚBLICA DOMINICANA' },
  { id: 150, name: 'RUANDA' },
  { id: 151, name: 'RUMANIA' },
  { id: 152, name: 'RUSIA' },
  { id: 153, name: 'SAMOA' },
  { id: 154, name: 'SAN CRISTÓBAL Y NIEVES' },
  { id: 155, name: 'SAN MARINO' },
  { id: 156, name: 'SAN VICENTE Y LAS GRANADINAS' },
  { id: 157, name: 'SANTA LUCÍA' },
  { id: 158, name: 'SANTO TOMÉ Y PRÍNCIPE' },
  { id: 159, name: 'SENEGAL' },
  { id: 160, name: 'SERBIA' },
  { id: 161, name: 'SEYCHELLES' },
  { id: 162, name: 'SIERRA LEONA' },
  { id: 163, name: 'SIRIA' },
  { id: 164, name: 'SOMALIA' },
  { id: 165, name: 'SRI LANKA' },
  { id: 166, name: 'SUAZILANDIA' },
  { id: 167, name: 'SUDÁFRICA' },
  { id: 168, name: 'SUDÁN' },
  { id: 169, name: 'SUDÁN DEL SUR' },
  { id: 170, name: 'SUECIA' },
  { id: 171, name: 'SUIZA' },
  { id: 172, name: 'SURINAM' },
  { id: 173, name: 'TAILANDIA' },
  { id: 174, name: 'TANZANIA' },
  { id: 175, name: 'TAYIKISTÁN' },
  { id: 176, name: 'TIMOR ORIENTAL' },
  { id: 177, name: 'TOGO' },
  { id: 178, name: 'TONGA' },
  { id: 179, name: 'TRINIDAD Y TOBAGO' },
  { id: 180, name: 'TÚNEZ' },
  { id: 181, name: 'TURKMENISTÁN' },
  { id: 182, name: 'TURQUÍA' },
  { id: 183, name: 'TUVALU' },
  { id: 184, name: 'UCRANIA' },
  { id: 185, name: 'UGANDA' },
  { id: 186, name: 'URUGUAY' },
  { id: 187, name: 'UZBEKISTÁN' },
  { id: 188, name: 'VANUATU' },
  { id: 190, name: 'VIETNAM' },
  { id: 191, name: 'YEMEN' },
  { id: 192, name: 'YIBUTI' },
  { id: 193, name: 'ZAMBIA' },
  { id: 194, name: 'ZIMBABUE' },
]